import { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
	const [user, setUser] = useState(null);

	useEffect(() => {
		const token = localStorage.getItem("token");
		if (token) {
			fetchUserData(token);
		}
	}, []);

	const fetchUserData = async (token) => {
		try {
			const res = await fetch("http://localhost:5000/api/auth/me", {
				headers: { Authorization: `Bearer ${token}` },
			});
			if (res.ok) {
				const data = await res.json();
				setUser(data);
			} else {
				localStorage.removeItem("token");
			}
		} catch (err) {
			console.error(err);
		}
	};

	return (
		<UserContext.Provider value={{ user, setUser }}>
			{children}
		</UserContext.Provider>
	);
};
